module.exports = __webpack_public_path__ + "img/results.6cb193b7.svg";